import gql from 'graphql-tag'

export const reviewsData = gql`
  query reviewList ($productId: Int) {
    reviewList (
      productId: $productId
    ) {
      items {
        created_at
        customer_id
        detail
        nickname
        rating_votes {
          percent
          rating_code
          rating_id
          value
          vote_id
        }
        review_id
        title
      }
    }
  }
`
